export function checkIsPromptEmpty(prompt: string) {
  return (prompt ?? '').trim().length === 0;
}
